import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import LinearProgress from "@material-ui/core/LinearProgress";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import { WithStyles, withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Delete from "@material-ui/icons/Delete";
import Edit from "@material-ui/icons/Edit";
import * as React from "react";
import { Link } from "react-router-dom";
import Component from "src/shared/components/Component";
import Modal from "src/shared/components/Modal";
import Page from "src/shared/components/Page";
import withAxios, { IAxiosProps } from "src/shared/components/withAxios";
import { ITemplate } from "src/api/types";
import { ITemplateAdminPageProps } from "./IAdminPageProps";
const styles = () => ({
  childTemplate: {
    paddingLeft: 80,
  },
  listItem: {
    "&:hover": {
      backgroundColor: "#e6e6e6",
    },
    backgroundColor: "white",
  },
});

type IProps = ITemplateAdminPageProps &
  IAxiosProps &
  WithStyles<keyof ReturnType<typeof styles>>;

interface ITemplateWithSchool extends ITemplate {
  school_name?: string;
}

interface ITemplatesPageState {
  deleteTemplate?: ITemplateWithSchool;
  modalVisible: boolean;
  filter: "all" | "schoolTemplate" | "master";
  loading?: boolean;
  items: ITemplateWithSchool[];
}

export default withStyles(styles)(
  withAxios(
    class TemplatesPage extends Component<IProps, ITemplatesPageState> {
      public readonly state = this.buildState({
        modalVisible: false,
        filter: "all",
        items: [],
      });

      public componentDidMount() {
        this.loadByFilter("all");
      }

      public render() {
        const { deleteTemplate, modalVisible } = this.state;
        return (
          <Page header="Manage Templates">
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "10px",
                marginBottom: 12,
              }}
            >
              <Button
                className="manage-template-inner"
                variant="contained"
                color="primary"
                component={Link}
                {...({ to: "/admin/templates/edit" } as any)}
                style={{
                  minWidth: 100,
                  fontWeight: 600,
                }}
              >
                Add
              </Button>

              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "flex-end",
                  gap: "8px",
                }}
              >
                {this.renderFilter()}
              </div>
            </div>

            {this.renderTemplateList()}
            {deleteTemplate === undefined ? null : (
              <Modal open={modalVisible} closeModal={this.closeModal}>
                <Grid
                  style={{ height: "100%" }}
                  container={true}
                  direction="column"
                  justifyContent="space-between"
                >
                  <Grid>
                    <h1>{deleteTemplate.name}</h1>
                    <span>
                      {/* Are you sure you want to delete {deleteTemplate.name}? */}
                      Are you sure you want to delete this template? Deleting it will affect all schools currently assigned to it.
                    </span>
                  </Grid>
                  <Grid container={true} justifyContent="space-between">
                    <Button onClick={this.closeModal} variant="contained">
                      Back
                    </Button>
                    <Button
                      onClick={this.deleteTemplate}
                      variant="contained"
                      color="secondary"
                    >
                      Delete
                    </Button>
                  </Grid>
                </Grid>
              </Modal>
            )}
          </Page>
        );
      }

      private renderTemplateList() {
        const { items, loading } = this.state;
        const visibleTemplates = items.filter((template) => template.parentId === null);
        return (
          <List>
            {loading && <LinearProgress />}
            <p>Total: {visibleTemplates.length}</p> {/* ✅ Only visible templates count */}
            {items
              .filter((template) => template.parentId === null)
              .map((template) => (
                <React.Fragment key={template.id}>
                  {this.renderTemplateListItem(template, false)}
                  {items
                    .filter((childTemp) => childTemp.parentId === template.id)
                    .map((childTemp) =>
                      this.renderTemplateListItem(childTemp, true)
                    )}
                </React.Fragment>
              ))}
          </List>
        );
      }

      private renderFilter() {
        const { filter } = this.state;
        return (
          <ButtonGroup
            color="primary"
            size="small"
            aria-label="template filter"
            style={{
              flexWrap: "wrap",
              height: "35px",
            }}
          >
            <Button
              variant={filter === "all" ? "contained" : "outlined"}
              onClick={() => this.loadByFilter("all")}
            >
              All
            </Button>
            <Button
              variant={filter === "schoolTemplate" ? "contained" : "outlined"}
              onClick={() => this.loadByFilter("schoolTemplate")}
            >
              School Templates
            </Button>
            <Button
              variant={filter === "master" ? "contained" : "outlined"}
              onClick={() => this.loadByFilter("master")}
            >
              Master Templates
            </Button>
          </ButtonGroup>
        );
      }


      private loadByFilter = (next: "all" | "schoolTemplate" | "master") =>
        void this.runCancellableStatefulAsync(
          this,
          { loading: true, filter: next },
          { loading: undefined },
          async () => {
            let endpoint = "template";
            if (next === "schoolTemplate") {
              endpoint = "template?type=schoolTemplate";
            } else if (next === "master") {
              endpoint = "template?type=master";
            }
            const data = await this.buildGet<ITemplateWithSchool[]>(this, endpoint)();
            this.setState({ items: data });
          },
          () => {
            this.setState({ loading: undefined });
            window.alert("Error loading templates");
          }
        );

      private renderTemplateListItem(
        template: ITemplateWithSchool,
        childTemplate: boolean
      ) {
        const { classes } = this.props;
        return (
          <ListItem
            divider={true}
            key={template.id}
            // className={`${childTemplate ? classes.childTemplate : null} ${
            //   classes.listItem
            // }`}
            className={classes.listItem}
            component={Link}
            {...({ to: `/admin/templates/edit/${template.id}` } as any)}
          >
            <ListItemText
              primary={`${template.name}`}
              secondary={
                template?.ismasterTemplate === false
                  ? `School: ${template?.school_name?.trim() ?? ""}`
                  : "Master Template"
              }
              primaryTypographyProps={{ style: { fontWeight: 600, color:
                    // "#007bff"
                    "#1a237e"
                } }}
              secondaryTypographyProps={{ style: { color: "#757575", fontSize: "0.85rem" } }}
            />

            <ListItemSecondaryAction>
              <Tooltip title="Edit" placement="left">
                <IconButton
                  aria-label="Edit"
                  component={Link}
                  {...({ to: `/admin/templates/edit/${template.id}` } as any)}
                >
                  <Edit />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete" placement="left">
                <IconButton
                  aria-label="Delete"
                  onClick={this.openModal(template)}
                >
                  <Delete />
                </IconButton>
              </Tooltip>
            </ListItemSecondaryAction>
          </ListItem>
        );
      }

      private closeModal = () => this.setState({ modalVisible: false });

      private openModal = (deleteTemplate: ITemplateWithSchool) => () =>
        this.setState({ modalVisible: true, deleteTemplate });

      private deleteTemplate = () =>
        void this.runCancellableStatefulAsync(
          this,
          {},
          {
            modalVisible: false,
          },
          async () => {
            const { deleteTemplate } = this.state;
            if (deleteTemplate !== undefined) {
              await this.buildDelete<void>(
                this,
                `template/${deleteTemplate.id}`
              )();
              this.loadByFilter(this.state.filter);
            }
          },
          () => {
            const { deleteTemplate } = this.state;
            window.alert(
              `Failed to delete template: ${
                deleteTemplate ? deleteTemplate.name : "undefined template"
              }`
            );
          }
        );
    }
  )
);



// WEBPACK FOOTER //
// ./src/features/admin/pages/TemplatesPage.tsx